import { React, useEffect, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Select,
  Modal,
  Divider,
  InputNumber,
  Checkbox,
  Row,
  Col,
} from 'antd';
import { HttpHandler } from '../../shared/httpHandler.js';
import PropTypes from 'prop-types';

const httpHandler = new HttpHandler();

let identityList = [];

// 新增、修改Modal
const ObjectModal = (props) => {
  const {
    isManageVisible,
    setIsManageVisible,
    customLoungeList,
    objectRecord,
    updateData,
  } = props;

  const [loading, setLoading] = useState(false);
  const [selectObject, setSelectObject] = useState([]);
  const [currentAmount, setCurrentAmount] = useState([]);
  const [modalForm] = Form.useForm();

  const addChange = async () => {
    const data = await modalForm.validateFields();
    const msg = '物品數量修改成功！';
    let postData = {};
    let objectDict = {};

    setLoading(true);

    for (let item = 0; item < identityList.length; item++) {
      const key = identityList[item];
      const value = modalForm.getFieldValue(`${objectRecord.name}_${key}`);

      objectDict[key] = value;
    }

    postData['provide_amenity'] = data.provideAmenity;
    postData['identity_list'] = identityList;
    postData['object_dict'] = objectDict;
    postData['location_name'] = objectRecord.name;
    postData['location_code'] = objectRecord.location_code;
    postData['location_id'] = objectRecord.id;
    postData['current_full'] = data.current_full || [];

    await httpHandler
      .post('/service_location/amenity_manage', postData)
      .then(async (response) => {
        console.log(response);
      })
      .finally(() => {
        modalForm.resetFields();
        updateData();
        setLoading(false);
        setIsManageVisible(false);
        setSelectObject([]);
        identityList = [];
        window.antdNotify('成功', msg, 'success');
      });
  };

  const handleModalSubmit = async () => {
    try {
      let alert = '確定修改用品數量？';

      const confirmed = await window.antdConfirm(alert);
      if (!confirmed) {
        return;
      }

      await addChange();
    } catch (error) {
      console.log(error);
    }
  };

  const handleModalCancel = () => {
    modalForm.resetFields();

    setLoading(false);
    setIsManageVisible(false);
    setSelectObject([]);
    identityList = [];
  };

  // 新增時的預設值
  useEffect(() => {
    setLoading(true);
    const totalData = {
      DLRBRNH: objectRecord ? objectRecord.location_code : '',
    };

    httpHandler
      .post('/service_location/search_deduct_detalil', totalData)
      .then((response) => {
        modalForm.setFieldsValue(response.data[0]);
        setCurrentAmount(response.data[1]);
      });

    modalForm.setFieldsValue({
      id: objectRecord ? objectRecord.id : null,
      provideAmenity: objectRecord ? objectRecord.provide_amenity : [],
    });

    setSelectObject(objectRecord ? objectRecord.provide_amenity : []);
    setLoading(false);
  }, [isManageVisible]);

  return (
    <Modal
      title={'用品管理'}
      open={isManageVisible}
      onCancel={handleModalCancel}
      footer={[
        <Button key="back" onClick={handleModalCancel}>
          取消
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleModalSubmit}
          loading={loading}>
          確定
        </Button>,
      ]}
      okButtonProps={{ loading: loading }}>
      <ModalForm
        modalForm={modalForm}
        customLoungeList={customLoungeList}
        selectObject={selectObject}
        setSelectObject={setSelectObject}
        objectRecord={objectRecord}
        currentAmount={currentAmount}
      />
    </Modal>
  );
};

// 共用Modal專用的Form(新增、修改共用)
const ModalForm = (props) => {
  const {
    modalForm,
    customLoungeList,
    selectObject,
    setSelectObject,
    objectRecord,
    currentAmount,
  } = props;

  const handleProvideListAllSelect = (value) => {
    if (value === 'allAmenity') {
      const nowList = modalForm.getFieldValue('provideAmenity');
      const amenityList = customLoungeList.filter(
        (item) => item.item_type === 2
      );
      if (nowList.length - 1 === amenityList.length) {
        modalForm.setFieldsValue({ provideAmenity: [] });
      } else {
        const amenityListId = amenityList.map((item) => item.id);
        modalForm.setFieldsValue({ provideAmenity: amenityListId });
      }
    }

    const object = modalForm.getFieldValue('provideAmenity');
    setSelectObject(object);

    identityList = [];
  };

  return (
    <Form
      form={modalForm}
      labelCol={{ span: 7 }} // 設置標籤佔據的列數
      wrapperCol={{ span: 16 }}>
      <Divider></Divider>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
      <Form.Item label="提供用品" name="provideAmenity">
        <Select
          mode="multiple"
          onSelect={(value) => handleProvideListAllSelect(value)}
          onDeselect={(value) => handleProvideListAllSelect(value)}>
          <Select.Option key="allAmenity" value="allAmenity">
            全部選擇
          </Select.Option>
          {customLoungeList
            .filter((item) => item.item_type === 2)
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
      {identityList.length > 0 && (
        <div
          style={{
            display: 'flex',
          }}>
          <span style={{ marginLeft: '36%' }}>庫存總數</span>
          <span style={{ marginLeft: '25%' }}>當前總數</span>
        </div>
      )}
      {selectObject.map((id) => {
        const item = customLoungeList.find((opt) => opt.id === id);
        if (!item) return null;

        if (!identityList.includes(item.id)) {
          identityList.push(item.id);
        }

        return (
          <Row gutter={20}>
            <Col span={18}>
              <Form.Item
                key={id}
                label={item.name}
                name={`${objectRecord.name}_${item.id}`}
                style={{ marginLeft: '4%' }}
                rules={[{ required: true, message: '請輸入庫存數量' }]}>
                <InputNumber style={{ width: '70%', marginLeft: '5%' }} />
              </Form.Item>
            </Col>
            <Col span={5}>
              <InputNumber
                name={`${objectRecord.name}_current_${item.id}`}
                value={
                  currentAmount[`${objectRecord.name}_current_${item.id}`] || 0
                }
                style={{ width: '190%', marginLeft: '-85%' }}
                disabled
              />
            </Col>
          </Row>
        );
      })}
      <Form.Item label={'補足當前數量'} name={'current_full'}>
        <Checkbox.Group>
          {selectObject.map((id) => {
            const item = customLoungeList.find((opt) => opt.id === id);
            if (!item) return null;

            return (
              <Checkbox key={item.id} value={item.id}>
                {item.name}
              </Checkbox>
            );
          })}
        </Checkbox.Group>
      </Form.Item>
      <Form.Item style={{ width: '130%' }}>
        <div style={{ color: '#888', lineHeight: 1.6 }}>
          <div>• 總庫存數量不可小於 1</div>
          <div>• 勾選「補足當前數量」會覆蓋現有庫存</div>
          <div>• 總庫存數 &lt; 當前庫存數，將自動調整當前庫存數為總庫存數 </div>
        </div>
      </Form.Item>
    </Form>
  );
};

// 驗證props
ObjectModal.propTypes = {
  isManageVisible: PropTypes.bool,
  setIsManageVisible: PropTypes.func,
  modalForm: PropTypes.object,
};

ModalForm.propTypes = {
  modalForm: PropTypes.object,
};

export default ObjectModal;
